import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import React from 'react';

// Create styles
const styles = StyleSheet.create({
  tableCol: {
    flex: 1,
    borderRightWidth: 1,
    marginBottom: -0.1,
    borderColor: '#bfbfbf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  tableCell: {
    fontSize: 8,
    paddingHorizontal: 4,
    paddingVertical: 2,
    textAlign: 'center',
  },
});
export default function TableCell({
  colSpan = 1,
  style = {},
  children,
}: {
  colSpan?: number;
  style?: Style | Style[];
  children?: React.ReactNode;
}) {
  return (
    <View style={[styles.tableCol, { flexGrow: colSpan }]}>
      {typeof children !== 'object' ? (
        <Text
          style={[
            styles.tableCell,
            ...(Array.isArray(style) ? [...style] : [style]),
          ]}
        >
          {children}
        </Text>
      ) : (
        <View
          style={[
            styles.tableCell,
            ...(Array.isArray(style) ? [...style] : [style]),
          ]}
        >
          {children}
        </View>
      )}
    </View>
  );
}
